<div style="height: 45px; margin-top:5px;">
  <div #paypal></div>
</div>
